import type { GiftPassDetail } from '../../api/gift-passes';

export function GiftPassCompRows({ comp }: { comp: NonNullable<GiftPassDetail['comp']> }) {
  return (
    <>
      <dt>Reason</dt>
      <dd>{comp.reason}</dd>
      {comp.createdByName && (
        <>
          <dt>Created by</dt>
          <dd>{comp.createdByName}</dd>
        </>
      )}
    </>
  );
}
